import classNames from 'classnames'
import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import businessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import { ConnectionIssue } from 'legacy/lut/components/widgets/public/ConnectionIssue'
import { ContactLogButton } from 'legacy/lut/components/widgets/public/ContactLogButton'
import { useEffect, useState } from 'react'

import { filterDuplicatesByKeys } from 'clickNgo/helpers/array'
import { Input } from 'core-components/library/inputs'
import { Loader } from 'core-components/library/loader'
import { NotificationController } from 'core-components/library/popup'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { HttpCancel } from 'core/classes/http'
import { CrudStore } from 'core/types/crudStore'

import styles from './ContactAdditionalRow.module.scss'

export interface IProps {
  contactId: string
  contact: DataModel
}

export const ContactAdditionalRow = ({ contactId, contact }: IProps) => {
  const [isLoading, setLoading] = useState(true)
  const [contactCampaigns, setContactCampaigns] = useState<any[]>([])
  const [userRights, setUserRights] = useState<any[]>([])
  const [contactCampaignsFilter, setContactCampaignsFilter] = useState('')
  const [userRightsFilter, setUserRightsFilter] = useState('')
  const [showAllCampaigns, setShowAllCampaigns] = useState(false)
  const [showAllUserRights, setShowAllUserRights] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAllCodes(contactId)
      .then((data) => {
        setContactCampaigns(filterDuplicatesByKeys(data.ContactCampaigns, 'CAMPAIGNS'))
        setUserRights(filterDuplicatesByKeys(data.UserRights, 'USER_RIGHTS'))
        setContactCampaignsFilter('')
        setUserRightsFilter('')
        setShowAllCampaigns(false)
        setShowAllUserRights(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [contactId])

  if (isLoading) {
    return <Loader />
  }
  return (
    <div className={styles.root}>
      <div className={styles.col}>
        <p className={styles.title}>Details Contact</p>
        <div className={styles.data}>
          <p className={styles.data__label}>Contact ID:</p>
          <p className={styles.data__value}>{contact.get('ContactID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Learner ID:</p>
          <p className={styles.data__value}>{contact.get('LearnerID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Gender:</p>
          <p className={styles.data__value}>{contact.get('Salutation')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Professional Title:</p>
          <p className={styles.data__value}>{}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>First Name:</p>
          <p className={styles.data__value}>{contact.get('FirstName')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Last Name:</p>
          <p className={styles.data__value}>{contact.get('LastName')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>HP Roles:</p>
          <p className={styles.data__value}>
            {(contact.get('PR_HP_ROLE') || '').replace(/;/g, ', ')}
          </p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Seniority:</p>
          <p className={styles.data__value}>{contact.get('Seniority')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Job Role:</p>
          <p className={styles.data__value}>
            {(contact.get('PrimaryJobRole') || '').replace(/;/g, ', ')}
          </p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Location ID:</p>
          <p className={styles.data__value}>{contact.get('LocationID')}</p>
        </div>
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Connect</p>
        <div className={styles.data}>
          <p className={styles.data__label}>Never Call:</p>
          <p className={styles.data__value}>{contact.get('NeverCall')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Mobile Phone:</p>
          <p className={styles.data__value}>
            <PhoneCall
              value={`${contact.get('MobilePhone_Prefix') || ''}${
                contact.get('MobilePhone') || ''
              }`}
              isContactLevel={!!contact.get('HPD_Contact_GUID')}
              guid={contact.get('HPD_Contact_GUID') || contact.get('HPD_Partner_GUID')}
              partnerId={contact.get('PartnerID')}
            />
          </p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Work Phone:</p>
          <p className={styles.data__value}>
            <PhoneCall
              value={`${contact.get('WorkPhone_Prefix') || ''}${contact.get('WorkPhone') || ''}`}
              isContactLevel={!!contact.get('HPD_Contact_GUID')}
              guid={contact.get('HPD_Contact_GUID') || contact.get('HPD_Partner_GUID')}
              partnerId={contact.get('PartnerID')}
            />
          </p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Main Phone:</p>
          <p className={styles.data__value}>
            <PhoneCall
              value={`${contact.get('MainPhone') || ''}`}
              isContactLevel={!!contact.get('HPD_Contact_GUID')}
              guid={contact.get('HPD_Contact_GUID') || contact.get('HPD_Partner_GUID')}
              partnerId={contact.get('PartnerID')}
            />
          </p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Never Email:</p>
          <p className={styles.data__value}>{contact.get('NeverEmail')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Email:</p>
          <p className={styles.data__value}>{contact.get('Email')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Email Office:</p>
          <p className={styles.data__value}>{contact.get('EmailCompany')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Last Update:</p>
          <p className={styles.data__value}>{contact.get('LastContactUpdateDate')}</p>
        </div>
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Location & User</p>
        <div className={styles.data}>
          <p className={styles.data__label}>Partner ID:</p>
          <p className={styles.data__value}>{contact.get('PartnerID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Communication Name:</p>
          <p className={styles.data__value}>{contact.get('CommunicationName')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>City:</p>
          <p className={styles.data__value}>{contact.get('City')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Country Of Business:</p>
          <p className={styles.data__value}>{contact.get('CountryOfBusiness')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Preferred Language:</p>
          <p className={styles.data__value}>{contact.get('PreferredLanguage')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>User Status:</p>
          <p className={styles.data__value}>{contact.get('UserStatus')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Login ID:</p>
          <p className={styles.data__value}>{contact.get('LoginID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>HP ID:</p>
          <p className={styles.data__value}>{contact.get('HPPassportProfileID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>HPD Contact GUID:</p>
          <p className={styles.data__value}>{contact.get('HPD_Contact_GUID')}</p>
        </div>
        <div className={styles.data}>
          <p className={styles.data__label}>Last Login:</p>
          <p className={styles.data__value}>{contact.get('UserLastLoginDate')}</p>
        </div>
      </div>

      <div className={styles.col}>
        <p className={styles.title}>User Rights</p>
        <Input
          classes={{
            root: styles.input,
          }}
          placeholder={'Search...'}
          onChange={(val) => setUserRightsFilter(val)}
        />
        {getParsedData(userRights, userRightsFilter, showAllUserRights).map(
          (item: any, index: any) => (
            <div key={index} className={styles.requests}>
              {getRequestsIcon(item.Status, item.Modified)}
              {item.USER_RIGHTS ? (
                <span>{item.USER_RIGHTS}</span>
              ) : (
                <span className={getClassRequests(item.Status, item.Action, item.Modified)}>
                  {item.Code}
                </span>
              )}
            </div>
          )
        )}
        {!showAllUserRights && userRights.length > 5 ? (
          <div className={styles.moreBtn} onClick={() => setShowAllUserRights(true)}>
            More
          </div>
        ) : null}
        {!userRights.length && <div>Not found</div>}
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Campaigns</p>
        <Input
          placeholder={'Search...'}
          classes={{
            root: styles.input,
          }}
          onChange={(val) => setContactCampaignsFilter(val)}
        />
        {getParsedData(contactCampaigns, contactCampaignsFilter, showAllCampaigns).map(
          (item: any, index: any) => (
            <div key={index} className={styles.requests}>
              {getRequestsIcon(item.Status, item.Modified)}
              {item.CAMPAIGNS ? (
                <span>{item.CAMPAIGNS}</span>
              ) : (
                <span className={getClassRequests(item.Status, item.Action, item.Modified)}>
                  {item.Code}
                </span>
              )}
            </div>
          )
        )}
        {!showAllCampaigns && contactCampaigns.length > 5 ? (
          <div className={styles.moreBtn} onClick={() => setShowAllCampaigns(true)}>
            More
          </div>
        ) : null}
        {!contactCampaigns.length && <div>Not found</div>}
      </div>

      <div className={styles.col}>
        <ContactLogButton contactID={contact.get('ContactID')} />
      </div>
    </div>
  )
}

const getAllCodes = async (contactID: any) => {
  let ContactCampaigns = []
  let UserRights = []

  if (contactID) {
    const contactFilter = {
      field: 'ContactId',
      operator: Operator.EQUAL,
      value: contactID,
    }

    const crudUserRights = CrudStore.get(
      CrudStoreItem.ContactCodeRequests,
      'ContactData-getAllCodes-UserRights'
    )

    const filterUserRights: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        contactFilter,
        {
          field: 'Type',
          operator: Operator.CONTAINS,
          value: 'UserRights',
        },
      ],
    }
    crudUserRights.setFilter(filterUserRights)
    const userRightsRequests = (await crudUserRights.fetch()).items

    const crudCampaigns = CrudStore.get(
      CrudStoreItem.ContactCodeRequests,
      'ContactData-getAllCodes-Campaigns'
    )
    const filterCampaigns: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        contactFilter,
        {
          field: 'Type',
          operator: Operator.CONTAINS,
          value: 'Campaigns',
        },
      ],
    }
    crudCampaigns.setFilter(filterCampaigns)
    const campaignsRequests = (await crudCampaigns.fetch()).items

    const result = await businessProfileStoreService.getUserRightsAndCampaigns(
      [contactID],
      new HttpCancel(),
      1000
    )
    const data = result && {
      ...result,
      userRights: {
        items: result.userRights.items.slice(),
        total: result.userRights.total,
      },
      contactCampaigns: {
        items: result.userRights.items.slice(),
        total: result.userRights.total,
      },
    }

    if (userRightsRequests && result && data) {
      let newUserRights = result.userRights.items.slice()
      userRightsRequests.forEach((item) => {
        newUserRights = newUserRights.filter((v) => v.USER_RIGHTS !== item.Code)
        newUserRights.push({ ...item, CONTACT_ID: contactID })
      })
      data.userRights.items = newUserRights
    }
    if (campaignsRequests && result && data) {
      let newCampaigns = result.contactCampaigns.items.slice()
      campaignsRequests.forEach((item) => {
        newCampaigns = newCampaigns.filter((v) => v.CAMPAIGNS !== item.Code)
        newCampaigns.push({ ...item, CONTACT_ID: contactID })
      })
      data.contactCampaigns.items = newCampaigns
    }
    if (!campaignsRequests) {
      NotificationController.show({
        content: () => <ConnectionIssue />,
      })
    }

    if (data) {
      ContactCampaigns = data.contactCampaigns.items
      UserRights = data.userRights.items
    }
  }

  return { ContactCampaigns, UserRights }
}

const getParsedData = (codes: any[], valueFilter: string, showAll: boolean) => {
  const filter = valueFilter.toUpperCase()
  let result = codes

  if (filter) {
    result = codes.filter(
      (v) =>
        (v.CodeName && ~v.CodeName.toUpperCase().indexOf(filter)) ||
        (v.Code && ~v.Code.toUpperCase().indexOf(filter))
    )
  }
  return result.slice(0, !showAll ? 5 : undefined)
}

const getRequestsIcon = (status: string, Modified: string) => {
  switch (status) {
    case 'WIP':
      return (
        <i
          className={classNames(
            styles.requests__icon,
            styles['requests--wip'],
            'kbase kbase-lvl-clock'
          )}
        />
      )
    case 'Rejected':
      return (
        <i
          className={classNames(
            styles.requests__icon,
            styles['requests--rejected'],
            'kbase kbase-info-alt'
          )}
        />
      )
    case 'Done':
      return (
        Modified &&
        Date.parse(Modified) > +new Date() - 86400000 && (
          <i
            className={classNames(
              styles.requests__icon,
              styles['requests--done'],
              'kbase kbase-check-circle'
            )}
          />
        )
      )
    case 'New':
      return (
        <i
          className={classNames(styles.requests__icon, styles['requests--new'], 'kbase kbase-add')}
        />
      )
  }
  return
}

const getClassRequests = (status: string, action: string, Modified: string) => {
  let styleStatus = ''
  if (status === 'WIP') {
    styleStatus = styles['requests--wip']
  } else if (status === 'Done' && Modified && Date.parse(Modified) > +new Date() - 86400000) {
    styleStatus = styles['requests--done']
  } else if (status === 'Rejected') {
    styleStatus = styles['requests--rejected']
  } else if (status === 'New') {
    styleStatus = styles['requests--new']
  }

  let styleAction = ''
  if (action === 'Delete') {
    styleAction = styles['requests--delete']
  }

  return classNames(styleAction, styleStatus)
}
